'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Body = exports.Header = exports.Dialog = exports.Backdrop = exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CustomCSSTransitionGroup = require('helpers/CustomCSSTransitionGroup');

var _CustomCSSTransitionGroup2 = _interopRequireDefault(_CustomCSSTransitionGroup);

var _Backdrop = require('../Backdrop');

var _Backdrop2 = _interopRequireDefault(_Backdrop);

var _Dialog = require('../Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Header = require('../Header');

var _Header2 = _interopRequireDefault(_Header);

var _Body = require('../Body');

var _Body2 = _interopRequireDefault(_Body);

var _Footer = require('../Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _Modal = require('./Modal.scss');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Modal, _Component);

  function Modal(props) {
    (0, _classCallCheck3.default)(this, Modal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props));

    _this.clearAnimating = function () {
      _this.setState({ animating: false });
    };

    _this.state = {};

    _this.onToggle = _this.onToggle.bind(_this);
    _this.onCancel = _this.onCancel.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.onToggle(this.props.isOpen);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.isOpen !== nextProps.isOpen) {
        this.setState({ animating: true }, function () {
          return _this2.onToggle(nextProps.isOpen);
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.isOpen) this.onToggle(false);
    }
  }, {
    key: 'onToggle',
    value: function onToggle(state) {
      if (this.props.onToggle) this.props.onToggle(state);
    }
  }, {
    key: 'onCancel',
    value: function onCancel(event, extra) {
      // Don't do anything while animating
      if (this.state.animating) return;

      if (this.props.isOpen && !this.props.isStatic && this.props.onCancel) {
        this.props.onCancel(event, extra);
      }
    }
  }, {
    key: 'getAnimatorClass',
    value: function getAnimatorClass() {
      return _CustomCSSTransitionGroup2.default;
    }
  }, {
    key: 'getAnimatorProps',
    value: function getAnimatorProps() {
      var animating = this.state.animating;
      var _props = this.props,
          transitionName = _props.transitionName,
          transitionEnter = _props.transitionEnter,
          transitionLeave = _props.transitionLeave,
          transitionDuration = _props.transitionDuration;


      return {
        transitionName: transitionName,
        transitionEnterTimeout: transitionEnter || transitionDuration,
        transitionLeaveTimeout: transitionLeave || transitionDuration,
        afterEnter: this.clearAnimating.bind(this),
        afterLeave: this.clearAnimating.bind(this),
        component: 'div',
        className: (0, _classnames2.default)('modal-wrapper', (0, _defineProperty3.default)({
          animating: animating
        }, _Modal2.default.animating, _Modal2.default.animating && animating)),
        animating: animating
      };
    }
  }, {
    key: '_renderModalBody',


    /* RENDERERS
    ----------------------------------------------------------------------------------------------- */
    value: function _renderModalBody() {
      var _props2 = this.props,
          autoWrap = _props2.autoWrap,
          children = _props2.children,
          bodyClassName = _props2.bodyClassName,
          isStatic = _props2.isStatic,
          isBasic = _props2.isBasic;


      if (autoWrap) {
        return _react2.default.createElement(
          _Body2.default,
          { className: (0, _classnames2.default)(bodyClassName, _Modal2.default.body), isStatic: isStatic, isBasic: isBasic },
          children
        );
      }

      return children;
    }
  }, {
    key: '_renderModalHeader',
    value: function _renderModalHeader() {
      var _props3 = this.props,
          headerClassName = _props3.headerClassName,
          header = _props3.header,
          isStatic = _props3.isStatic,
          isBasic = _props3.isBasic;


      if (!header) {
        // No header: Return nothing
        return null;
      } else if (typeof header === 'string') {
        // Header is a string, return a ModalHeader
        return _react2.default.createElement(
          _Header2.default,
          {
            className: (0, _classnames2.default)(headerClassName, _Modal2.default.header),
            addClose: !isBasic && !isStatic,
            isStatic: isStatic,
            isBasic: isBasic,
            onCancel: this.onCancel
          },
          header
        );
      }

      // Fall back to rendering header directly (events should be handled by parent)
      return header;
    }
  }, {
    key: '_renderModalFooter',
    value: function _renderModalFooter() {
      var _props4 = this.props,
          footerClassName = _props4.footerClassName,
          footer = _props4.footer,
          isStatic = _props4.isStatic,
          isBasic = _props4.isBasic;


      if (!footer) return null;

      return _react2.default.createElement(
        _Footer2.default,
        {
          className: (0, _classnames2.default)(footerClassName, _Modal2.default.header),
          isStatic: isStatic,
          isBasic: isBasic
        },
        footer
      );
    }
  }, {
    key: '_renderModal',
    value: function _renderModal() {
      var _props5 = this.props,
          backdropClassName = _props5.backdropClassName,
          dialogClassName = _props5.dialogClassName,
          isOpen = _props5.isOpen,
          isBasic = _props5.isBasic,
          isStatic = _props5.isStatic;


      if (!isOpen) return [];

      var parts = [_react2.default.createElement(_Backdrop2.default, {
        className: (0, _classnames2.default)(backdropClassName, _Modal2.default.backdrop),
        isStatic: isStatic,
        isBasic: isBasic,
        onCancel: this.onCancel,
        key: 'backdrop'
      }), _react2.default.createElement(
        _Dialog2.default,
        {
          className: (0, _classnames2.default)(dialogClassName, _Modal2.default.dialog),
          isStatic: isStatic,
          isBasic: isBasic,
          onCancel: this.onCancel,
          key: 'dialog'
        },
        this._renderModalHeader(),
        this._renderModalBody(),
        this._renderModalFooter()
      )];

      return parts;
    }
  }, {
    key: 'render',
    value: function render() {
      var Animator = this.getAnimatorClass();

      return _react2.default.createElement(
        Animator,
        this.getAnimatorProps(),
        this._renderModal()
      );
    }
  }]);
  return Modal;
}(_react.Component), _class.Backdrop = _Backdrop2.default, _class.Dialog = _Dialog2.default, _class.Header = _Header2.default, _class.Body = _Body2.default, _class.propTypes = {
  isOpen: _react.PropTypes.bool.isRequired,
  onCancel: _react.PropTypes.func.isRequired,
  onConfirm: _react.PropTypes.func,

  children: _react.PropTypes.node,

  isStatic: _react.PropTypes.bool,
  isBasic: _react.PropTypes.bool,
  autoWrap: _react.PropTypes.bool,

  header: _react.PropTypes.node,
  footer: _react.PropTypes.node,

  // This is internally used
  onToggle: _react.PropTypes.func,

  backdropClassName: _react.PropTypes.string,
  dialogClassName: _react.PropTypes.string,
  headerClassName: _react.PropTypes.string,
  footerClassName: _react.PropTypes.string,
  bodyClassName: _react.PropTypes.string,

  transitionDuration: _react.PropTypes.number,
  transitionEnter: _react.PropTypes.number,
  transitionLeave: _react.PropTypes.number,
  transitionName: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.shape({
    enter: _react.PropTypes.string,
    leave: _react.PropTypes.string,
    active: _react.PropTypes.string
  }), _react.PropTypes.shape({
    enter: _react.PropTypes.string,
    enterActive: _react.PropTypes.string,
    leave: _react.PropTypes.string,
    leaveActive: _react.PropTypes.string,
    appear: _react.PropTypes.string,
    appearActive: _react.PropTypes.string
  })])
}, _class.defaultProps = {
  autoWrap: true,
  keyboard: true,
  transitionName: {
    enter: _Modal2.default['animating--enter'],
    leave: _Modal2.default['animating--leave']
  },
  transitionDuration: 300
}, _temp);
exports.default = Modal;
exports.Backdrop = _Backdrop2.default;
exports.Dialog = _Dialog2.default;
exports.Header = _Header2.default;
exports.Body = _Body2.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseModal/Modal/Modal.jsx
// module id = 1604
// module chunks = 0